import api from "@/lib/utils/api";

export const fetchPermissionsForUserById = async (userId) => {
  try {
    const { data } = await api.get(`/users/${userId}/permissions`);

    const { permissions, context, hasWildcard: apiHasWildcard } = data;
    const permissionsArray = permissions?.member || permissions || [];

    return { permissionsArray, context, hasWildcard: apiHasWildcard };
  } catch (error) {
    console.error("Failed to fetch permissions for user:", userId, error);
    return { permissionsArray: [], context: null, hasWildcard: false };
  }
};
